import { WorkspaceListCtx } from "../contexts/WorkspaceListCtx";
import { workspaceStore } from "../stores/workspaceStore";
import { httpService } from "./httpService";

export type CreateWorkspaceData = {
  name: string;
  description: string;
  website: string;
};

export const workspaceService = {
  async list(isLoading = true) {
    try {
      isLoading && workspaceStore.setLoading(true); // Set loading state
      const workspacesListResp = await httpService.getRequest<any>("workspaces");
      const workspaces = workspacesListResp.data.data;
      workspaceStore.setWorkspaces(workspaces); // Update workspaces and reset loading
      WorkspaceListCtx.setOtherDetails({
        show_updated_banner: workspacesListResp?.show_updated_banner,
        updated_banner_video: workspacesListResp?.updated_banner_video,
      });
      return workspacesListResp;
    } catch (error) {
      console.error("Error fetching workspaces:", error);
      workspaceStore.setLoading(false); // Reset loading on error
    }
  },

  validateCreate() {
    return httpService.getRequest("workspaces/validate-create");
  },

  validateDelete(uniqueWorkspaceId: string) {
    return httpService.getRequest(`workspaces/${uniqueWorkspaceId}/validate-delete`);
  },

  create(formData: FormData) {
    return httpService.postFormDataRequest("workspaces", formData);
  },

  update(wsUniqueId: string, formData: FormData) {
    formData.append("_method", "PUT");
    return httpService.postFormDataRequest(`workspaces/${wsUniqueId}`, formData);
  },

  delete(wsUniqueId: string) {
    return httpService.deleteRequest(`workspaces/${wsUniqueId}`);
  },
};